<script type="text/jsx">
    import * as moment from 'moment';
    import 'moment-timezone';
    moment.tz.setDefault('America/Boise');
    moment.locale('en');
    export const tempo = moment;
</script>


// WEBPACK FOOTER //
// moment.vue?36cdf214